import Config from "../../Config";
import {
  color_black,
  color_black_ultra_light,
  color_red_default,
  color_white,
} from "../../constants/colors";
import betaStickerIcon from "../../images/beta.svg";
import createLessonIcon from "../../images/CreateLessonIcon.svg";
import timeCircleIcon from "../../images/TimeCircle.svg";
import { useWindowDimensions } from "../../utils";
import { useI18n } from "../../i18n/I18nProvider";
import ArrowIcon from "../icons/ArrowIcon";
import EditIcon from "../icons/EditIcon";
import {
  OnestMediumExtraSmall,
  OnestSemiBoldBig,
} from "../styled/TextComponents";
import { styles as studentProfileStyles } from "./studentProfile/studentInfo/styles.js";

/**
 * Режим «Создать урок» + soon: вся кнопка целиком с opacity 0.5 (фон, текст, иконка).
 * Плашка «soon» снаружи button — остаётся непрозрачной.
 * Поставь `false` — снова только лёгкое затемнение кнопки (opacity 0.85), без «стекла» на всё.
 */
export const CREATE_LESSON_SOON_TRANSPARENT_BUTTON = true;

export const ImageBlock = ({
  imageLink,
  profileName,
  changeButtonHandler,
  changeImageButtonHandler,
  secondaryButtonLabel,
  secondaryButtonHandler,
  /** Плашка «Soon» и disabled, пока функция недоступна */
  secondaryButtonComingSoon = false,
  /** Плашка «Beta» поверх активной кнопки */
  secondaryButtonBeta = false,
}) => {
  const { width: screenWidth } = useWindowDimensions();
  const { t } = useI18n();
  const soonTransparent =
    secondaryButtonComingSoon && CREATE_LESSON_SOON_TRANSPARENT_BUTTON;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: screenWidth >= 768 ? "row" : "column",
        alignItems: screenWidth >= 768 ? "center" : "flex-start",
        boxSizing: "border-box",
        gap: 12,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 12,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 66, // размер аватара по макету (66×66)
            height: 66,
            position: "relative",
            cursor: "pointer",
          }}
          onClick={changeImageButtonHandler}
        >
          <img
            style={{
              width: 66,
              height: 66,
              borderRadius: "50%",
              objectFit: "cover",
            }}
            alt={"Profile"}
            src={
              imageLink
                ? Config.CLOUD_ADDR + "/" + imageLink
                : window.location.origin + "/no_profile_icon.png"
            }
          />
          <div
            style={{
              ...studentProfileStyles.studentImageChangeButton,
              width: 24,
              height: 24,
            }}
          >
            <EditIcon fill={color_white} width={10} height={10} />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            alignSelf: screenWidth >= 768 ? "center" : "flex-start",
            gap: 12, // расстояние между именем и «Изменить >»
          }}
        >
          {/* Имя: на мобиле — слева, на десктопе — nowrap. Шрифт 20px / line-height 24px по макету */}
          <OnestSemiBoldBig
            style={{
              ...(screenWidth >= 768 && { whiteSpace: "nowrap" }),
              fontSize: 20,
              lineHeight: "24px",
              textAlign: "left",
            }}
          >
            {profileName}
          </OnestSemiBoldBig>
          <span
            onClick={changeButtonHandler}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              cursor: "pointer",
              fontSize: 14,
              lineHeight: "15px",
              letterSpacing: 0,
              fontWeight: 400,
              color: color_black_ultra_light,
              fontFamily: "Onest",
            }}
          >
            {t("Изменить")}{" "}
            <ArrowIcon fill={color_black_ultra_light} width={15} height={15} />
            {/* размер стрелки по макету (15×15) */}
          </span>
        </div>
      </div>
      {/* На десктопе: растягивающийся spacer между блоком имени и кнопками — прижимает кнопки вправо */}
      {screenWidth >= 768 && <div style={{ flexGrow: 1 }} />}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8, // расстояние между кнопками «Изменить профиль» и «Создать урок»
          alignItems: screenWidth >= 768 ? "flex-end" : "center",
          alignSelf: screenWidth >= 768 ? "flex-start" : "stretch",
        }}
      >
        {secondaryButtonLabel && secondaryButtonHandler && (
          <div
            style={{
              position: "relative",
              display: "inline-block",
              width: screenWidth < 768 ? "100%" : "auto",
              alignSelf: screenWidth >= 768 ? "flex-end" : "stretch",
            }}
          >
            <button
              type="button"
              disabled={secondaryButtonComingSoon}
              onClick={
                secondaryButtonComingSoon ? undefined : secondaryButtonHandler
              }
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: screenWidth >= 768 ? undefined : "center",
                gap: 8,
                padding: "10px 20px",
                borderRadius: 15,
                backgroundColor: color_white,
                color: color_black,
                border: "none",
                fontFamily: "Onest",
                fontWeight: 500,
                fontSize: 16,
                cursor: secondaryButtonComingSoon ? "not-allowed" : "pointer",
                opacity: soonTransparent
                  ? 0.5
                  : secondaryButtonComingSoon
                    ? 0.85
                    : 1,
                ...(screenWidth < 768 && { width: "100%" }),
              }}
            >
              <img
                src={createLessonIcon}
                alt=""
                width={20}
                height={15}
                style={{ display: "block" }}
              />
              {secondaryButtonLabel}
            </button>
            {(secondaryButtonComingSoon || secondaryButtonBeta) && (
              <div
                style={{
                  position: "absolute",
                  top: -6,
                  right: -4,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 4,
                  width: 54,
                  height: 20,
                  padding: "4px 6px",
                  backgroundColor: color_white,
                  borderRadius: 6,
                  boxSizing: "border-box",
                  pointerEvents: "none",
                }}
              >
                {secondaryButtonBeta ? (
                  <img
                    src={betaStickerIcon}
                    alt="beta"
                    width={52}
                    height={20}
                    style={{ display: "block", flexShrink: 0 }}
                  />
                ) : (
                  <>
                    <img
                      src={timeCircleIcon}
                      alt=""
                      width={12}
                      height={12}
                      style={{ display: "block", flexShrink: 0 }}
                    />
                    <OnestMediumExtraSmall
                      style={{
                        color: color_red_default,
                        lineHeight: "12px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      soon
                    </OnestMediumExtraSmall>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
